/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as promotionActions from './Promotion-Actions';
import * as promotionOperations from './Promotion-Operations';

const promotionWatcherSagas = [
    ...promotionOperations.watchers,
];

export {
    promotionActions,
    promotionOperations,
    promotionWatcherSagas,
};

export default {};
